"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taxComposeFunction = taxComposeFunction;
exports.hasPattern = hasPattern;
exports.getWinthorTaxFunction = getWinthorTaxFunction;
async function taxComposeFunction(input, promiseFunction) {
    let output = input;
    let match;
    while ((match = hasPattern(output))) {
        const replacement = await promiseFunction(match);
        if (replacement) {
            output = output.replace(`#${match}#`, replacement);
        }
    }
    return output;
}
function hasPattern(input) {
    const match = input.match(/#(\w+)#/);
    return match ? match[1] : null;
}
function getWinthorTaxFunction(parameter) {
    if (parameter.usavalorultentbasest)
        return "PVENDA_RJ_ULT_ENT";
    if (parameter.usavalorultentbasest2)
        return "PVENDA_RJ_ULT_ENT_NO_ST2";
    if (parameter.usavalorultentbasestfonte && parameter.usavalorultentbasest2)
        return "PVENDA_RJ_ULT_ENT_NO_ST2";
    if (parameter.usavlultentmediobasest)
        return "PVENDA_MG";
    if (parameter.usapmcbasest)
        return "PVENDA_PMAXCONSUM";
    if (parameter.usabaseicmsreduzida)
        return "PVENDA_BASE_RED_ICMS";
    if (parameter.pauta > 0)
        return "PVENDA_ST_PAUTA";
    if (parameter.agregaicmsisencaost1 ||
        parameter.agregasuframast1 ||
        parameter.agregapiscofinsst1 ||
        parameter.agregadescst1 ||
        parameter.agregaicmsisencaost2 ||
        parameter.agregasuframast2 ||
        parameter.agregapiscofinsst2 ||
        parameter.agregadescst2) {
        return "PVENDA_DESCONTOS";
    }
    if (parameter.utilizacalculostmt)
        return "PVENDA_ST_MT";
    if (parameter.agregaripicalculost)
        return "PVENDA_COM_IPI_ST2";
    return "PVENDA";
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mdW5jdGlvbnMvdGF4L3V0aWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxnREFlQztBQUVELGdDQUdDO0FBRUQsc0RBOEJDO0FBcERNLEtBQUssVUFBVSxrQkFBa0IsQ0FDdEMsS0FBYSxFQUNiLGVBQW1EO0lBRW5ELElBQUksTUFBTSxHQUFHLEtBQUssQ0FBQztJQUNuQixJQUFJLEtBQUssQ0FBQztJQUVWLE9BQU8sQ0FBQyxLQUFLLEdBQUcsVUFBVSxDQUFDLE1BQU0sQ0FBQyxDQUFDLEVBQUUsQ0FBQztRQUNwQyxNQUFNLFdBQVcsR0FBRyxNQUFNLGVBQWUsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNqRCxJQUFJLFdBQVcsRUFBRSxDQUFDO1lBQ2hCLE1BQU0sR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDLElBQUksS0FBSyxHQUFHLEVBQUUsV0FBVyxDQUFDLENBQUM7UUFDckQsQ0FBQztJQUNILENBQUM7SUFFRCxPQUFPLE1BQU0sQ0FBQztBQUNoQixDQUFDO0FBRUQsU0FBZ0IsVUFBVSxDQUFDLEtBQWE7SUFDdEMsTUFBTSxLQUFLLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUNyQyxPQUFPLEtBQUssQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7QUFDakMsQ0FBQztBQUVELFNBQWdCLHFCQUFxQixDQUNuQyxTQUF1QztJQUV2QyxJQUFJLFNBQVMsQ0FBQyxvQkFBb0I7UUFBRSxPQUFPLG1CQUFtQixDQUFDO0lBQy9ELElBQUksU0FBUyxDQUFDLHFCQUFxQjtRQUFFLE9BQU8sMEJBQTBCLENBQUM7SUFDdkUsSUFBSSxTQUFTLENBQUMseUJBQXlCLElBQUksU0FBUyxDQUFDLHFCQUFxQjtRQUN4RSxPQUFPLDBCQUEwQixDQUFDO0lBRXBDLElBQUksU0FBUyxDQUFDLHNCQUFzQjtRQUFFLE9BQU8sV0FBVyxDQUFDO0lBQ3pELElBQUksU0FBUyxDQUFDLFlBQVk7UUFBRSxPQUFPLG1CQUFtQixDQUFDO0lBQ3ZELElBQUksU0FBUyxDQUFDLG1CQUFtQjtRQUFFLE9BQU8sc0JBQXNCLENBQUM7SUFDakUsSUFBSSxTQUFTLENBQUMsS0FBSyxHQUFHLENBQUM7UUFBRSxPQUFPLGlCQUFpQixDQUFDO0lBRWxELElBQ0UsU0FBUyxDQUFDLG9CQUFvQjtRQUM5QixTQUFTLENBQUMsZ0JBQWdCO1FBQzFCLFNBQVMsQ0FBQyxrQkFBa0I7UUFDNUIsU0FBUyxDQUFDLGFBQWE7UUFDdkIsU0FBUyxDQUFDLG9CQUFvQjtRQUM5QixTQUFTLENBQUMsZ0JBQWdCO1FBQzFCLFNBQVMsQ0FBQyxrQkFBa0I7UUFDNUIsU0FBUyxDQUFDLGFBQWEsRUFDdkIsQ0FBQztRQUNELE9BQU8sa0JBQWtCLENBQUM7SUFDNUIsQ0FBQztJQUVELElBQUksU0FBUyxDQUFDLGtCQUFrQjtRQUFFLE9BQU8sY0FBYyxDQUFDO0lBQ3hELElBQUksU0FBUyxDQUFDLG1CQUFtQjtRQUFFLE9BQU8sb0JBQW9CLENBQUM7SUFFL0QsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQyJ9